export default __webpack_public_path__ + "static/media/logo.c231da9e.png";